import type { ComponentProps } from 'react'
import React, { memo } from 'react'

import { linkEvent } from '@app/utils/routing/events'
import { Link } from '@app/utils/routing/Link'

import { intoResult, unwrapOr } from '@app/packages/Result/Result'
import { useRouter } from '@app/packages/routing/RouterContext'

import { Icon } from '@app/components/Icon/Icon'

import classes from './Logo.module.scss'

type Props = Omit<ComponentProps<'a'>, 'ref' | 'defaultValue' | 'aria-relevant'>

export const Logo = memo<Props>(function Logo({ className, ...aprops }) {
  const router = unwrapOr(
    // eslint-disable-next-line react-hooks/rules-of-hooks
    intoResult(() => useRouter()),
    null
  )

  if (!router)
    return (
      <a className={cn(classes.logo, className)} href="/" {...aprops}>
        Kidsout
        <Icon className={classes.svg} icon="logo" />
      </a>
    )

  return (
    <Link
      className={cn(classes.logo, className)}
      event={linkEvent('logo.logo_link')}
      region={true}
      rel={router.location.pathname === '/' ? 'nofollow' : undefined}
      to="/"
      {...aprops}
    >
      Kidsout
      <Icon className={classes.svg} icon="logo" />
    </Link>
  )
})
